const LANG_LEVELS = ["Expert", "Very Good", "Good User", "Competent", "Modest", "Limited"];

export default LANG_LEVELS;
